var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 0L6 5.332.668 0 0 .668l5.332 5.331L0 11.332.668 12 6 6.668 11.332 12l.668-.668-5.332-5.333L12 .668z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICA8cG9seWdvbiBwb2ludHM9IjExLjMzMiAwIDYgNS4zMzIgLjY2OCAwIDAgLjY2OCA1LjMzMiA1Ljk5OSAwIDExLjMzMiAuNjY4IDEyIDYgNi42NjggMTEuMzMyIDEyIDEyIDExLjMzMiA2LjY2OCA1Ljk5OSAxMiAuNjY4Ii8+Cjwvc3ZnPgo=";
export { SvgClose as ReactComponent };